import { useCallback, useReducer } from 'react';
import axios from 'axios';
import ActionTypes from '../Action.types';
import VpsAlertReducer from './vpsAlert.reducer';

const INITIAL_STATE = {
  vpsAlerts: [],
  isLoading: false,
  errMessage: '',
};

const VpsAlertHooks = () => {
  const [state, dispatch] = useReducer(VpsAlertReducer, INITIAL_STATE);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const findVpsAlerts = useCallback(async () => {
    try {
      const res: any = await axios.get(`${backendUrl}/vps`);

      const data = res.data.map((data: any) => {
        return {
          ...data,
          id: data._id,
          createdAt: new Date(data.createdAt).toLocaleDateString('en-EN'),
          updatedAt: new Date(data.updatedAt).toLocaleDateString('en-EN'),
          expDate: new Date(data.expDate).toLocaleDateString('en-EN'),
        };
      });

      dispatch({ type: ActionTypes.find, payload: data });
    } catch (err: any) {
      actionError(err);
    }
  }, [backendUrl]);

  const createVpsAlert = async (vpsAlert: any) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      const data = {
        ...vpsAlert,
        id: vpsAlert._id,
        createdAt: new Date(vpsAlert.createdAt).toLocaleDateString('en-EN'),
        updatedAt: new Date(vpsAlert.updatedAt).toLocaleDateString('en-EN'),
        expDate: new Date(vpsAlert.expDate).toLocaleDateString('en-EN'),
      };

      dispatch({ type: ActionTypes.create, payload: data });
    } catch (err) {
      actionError(err);
    }
  };

  const updateVpsAlert = async (vpsAlert: any) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      const data = {
        ...vpsAlert,
        id: vpsAlert._id,
        createdAt: new Date(vpsAlert.createdAt).toLocaleDateString('en-EN'),
        updatedAt: new Date(vpsAlert.updatedAt).toLocaleDateString('en-EN'),
        expDate: new Date(vpsAlert.expDate).toLocaleDateString('en-EN'),
      };

      dispatch({ type: ActionTypes.update, payload: data });
    } catch (err) {
      actionError(err);
    }
  };

  const deleteVpsAlert = async (vpsId: string) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({ type: ActionTypes.delete, payload: vpsId });
    } catch (err) {
      actionError(err);
    }
  };

  const actionError = (err: any) => {
    if (err.response) {
      dispatch({
        type: ActionTypes.error,
        payload: err.response.data.message,
      });
    } else {
      dispatch({
        type: ActionTypes.error,
        payload: err.message,
      });
    }
  };

  return {
    state,
    findVpsAlerts,
    createVpsAlert,
    updateVpsAlert,
    deleteVpsAlert,
  };
};

export default VpsAlertHooks;
